import {RFValue} from 'react-native-responsive-fontsize';
import TextInputMask from 'react-native-text-input-mask';
import styled from 'styled-components/native';

export const Container = styled.View``;

export const Label = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;

export const InputField = styled(TextInputMask)`
  height: ${RFValue(45)}px;
  border-style: solid;
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.border};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.regular};
`;
